export default __webpack_public_path__ + "static/media/sanmat16.48e3963c.jpg";